module.exports = __webpack_public_path__ + "media/images/icons/close-52d0d27dcc749833a0759f86da533013.svg";